{
	"type": "circle",
	"minzoom": 8,
	"layout": {},
	"paint": {
		"circle-stroke-width": 0.8,
		"circle-color": [
			"match",
			["get", "infrastructuretype"],
			"Raised Crossing",
			"#1b9e77",
			"Vertical Deflection",
			"#d95f02",
			"Raised Pedestrian Crossing/ Vertical Deflection",
			"#377eb8",
			"Kerb extensions",
			"#7570b3",
			"Kerb extension",
			"#7570b3",
			"#ddd"
		],
		"circle-stroke-color": "#ddd",
		"circle-radius": 4.8,
		"circle-stroke-opacity": 0.6
	}
}
